import { render, staticRenderFns } from "./FilterBarGenres.vue?vue&type=template&id=351a2f1e&scoped=true"
import script from "./FilterBarGenres.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilterBarGenres.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FilterBarGenres.vue?vue&type=style&index=0&id=351a2f1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351a2f1e",
  null
  
)

export default component.exports